import script from "./AchievementsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsGroup.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsGroup.vue?vue&type=style&index=0&id=2078ff5d&lang=scss"

const __exports__ = script;

export default __exports__